var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerifiedVerification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_958_16052)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "url(#paint0_linear_958_16052)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6315 7.04514C13.7009 7.07494 13.7638 7.11861 13.8167 7.17363C13.8745 7.2286 13.9206 7.29531 13.9522 7.36957C13.9837 7.44382 14 7.52401 14 7.60507C14 7.68614 13.9837 7.76632 13.9522 7.84058C13.9206 7.91483 13.8745 7.98154 13.8167 8.03651L9.17176 12.8264C9.11884 12.8814 9.05588 12.9251 8.98651 12.9549C8.91714 12.9847 8.84274 13 8.7676 13C8.69245 13 8.61805 12.9847 8.54868 12.9549C8.47931 12.9251 8.41635 12.8814 8.36344 12.8264L6.17756 10.5723C6.12261 10.5176 6.07866 10.4522 6.04821 10.38C6.01776 10.3077 6.00141 10.23 6.00009 10.1513C5.99877 10.0725 6.0125 9.99423 6.04051 9.92094C6.06852 9.84765 6.11025 9.78077 6.16333 9.72411C6.2164 9.66746 6.27978 9.62213 6.34984 9.59073C6.4199 9.55933 6.49527 9.54247 6.57166 9.54111C6.64804 9.53975 6.72393 9.55391 6.795 9.58279C6.86607 9.61167 6.93093 9.65471 6.98588 9.70944L8.7676 11.5526L13.0084 7.17363C13.0613 7.11861 13.1243 7.07494 13.1937 7.04514C13.263 7.01534 13.3374 7 13.4126 7C13.4877 7 13.5621 7.01534 13.6315 7.04514Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_958_16052",
    x: -5,
    y: -5,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_958_16052"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_958_16052",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_958_16052",
    x1: 20,
    y1: -0.00000204859,
    x2: -8.11799,
    y2: 11.2866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3E040"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedVerification);
export default __webpack_public_path__ + "static/media/verified-verification.f70f960a1edbe35441ac9443a7ec7ab2.svg";
export { ForwardRef as ReactComponent };